module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "slide2.2ec3bb93.jpg" + "?" + Date.now();